<template>
    <div class="all-page">

        <home-nav ref="homeNavRef" class="m-hidden-view"></home-nav>
        <gzh-code-view class="m-hidden-view"></gzh-code-view>

        <app-title :title-name="gameName"></app-title>

        <div class="p-title">
            <div style="height: 70px;padding-left: 30px;display: flex;align-items: center;color: #666666">
                <span>当前位置：</span>
                <span style="margin-left: 10px;">首页</span>
                <span style="margin-left: 10px;">></span>
                <span style="margin-left: 10px;">{{gameName}}</span>
            </div>
        </div>

        <app-top-space></app-top-space>
        <div class="main-page">
            <div style="width: 100%; display: flex;justify-content: space-between;">
                <div class="game-info">
                    <img :src="logoUrl" class="game-icon-img">
                    <div class="game-text">
                        <span class="game-name-text" style="font-weight: bold;">{{gameName}}</span>
                        <div class="tags">
                            <span v-for="item in tagList">{{item}}</span>
                        </div>
                        <div class="topic-view" style="color: #888888">
                            <span>{{topic}}</span>
                            <span style="margin-left: 15px;color: #e56363">{{gameSize}}</span>
                        </div>
                    </div>
                    <div style="flex: 1"></div>

                    <div>
                        <div v-if="!!gameUrl" class="m-hidden-view p-play-button" @click="playGamePC">
                            在线玩
                        </div>
                        <div @click="downloadGame" class="download-button">
                            <span>游戏下载</span>
                        </div>
                    </div>

                </div>

                <div class="code-view">
                    <div v-if="!isM" class="code-div">
                        <div class="code-inner">
                            <div class="qr-code" ref="qrCodeUrl"></div>
                            <span style="font-size: 12px;color: #888888;margin-top: 10px">手机扫码下载游戏</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info-model">
                <div class="main-title">
                    游戏简介
                    <div class="title-line"></div>
                </div>
                <video v-if="!!videoUrl" :src="videoUrl" style="width: calc(100% - 20px); margin: 10px 20px 0; object-fit:cover;border-radius: 5px;"
                       :poster="videoImgUrl" :controls="true" :autoplay="false"></video>
                <div style="font-size: 15px;margin: 10px 20px 10px;line-height: 28px;" v-html="gameDesc">
                </div>
            </div>

            <div class="info-model">
                <div class="main-title">
                    <span>
                        游戏礼包
                    </span>
                    <span v-if="giftInfoList.length > 3" @click="expandGiftList" class="expend-btn">
                        {{giftShowNum === 3 ? '展开全部' : '收起'}}
                    </span>
                    <div class="title-line"></div>
                </div>

                <div style="font-size: 15px;margin: 10px 20px 10px;">
                    <div v-if="giftInfoList.length > 0">
                        <div v-for="(item,index) in giftInfoList" v-show="index < giftShowNum" @click="openGift(index)" style="background-color:#f8f8f8;;padding: 10px 20px;margin-top: 5px;border-radius: 8px;">
                            <div style="display: flex;align-items: center;justify-content: space-between;border-radius: 4px;cursor:pointer;">
                                <div style="display: flex;flex-direction: column;align-items: flex-start;margin-right: 20px;">
                                    <span style="font-size: 14px;color: #555555;font-weight: bold;">{{item.giftName}}</span>
                                    <span  style="font-size: 12px;color: #666666;margin-top: 5px;" class="text-info-desc">{{item.giftContent}}</span>
                                </div>
                                <van-icon :class="item.open === 1 ? 'gift-show-icon' : 'gift-hide-icon'" name="arrow" color="#cccccc" size="18"/>
                            </div>

                            <div :class="selectGiftClass(item.open)" class="gift-more-init">
                                <div class="game-detail-info" style="margin-top: 10px;">
                                    <span style="font-size: 13px;">领取条件</span>
                                </div>
                                <span style="margin: 10px 10px 10px;display: block">
                                    {{item.giftCondition || '无'}}
                                </span>
                                <div class="game-detail-info" style="margin-top: 5px;">
                                    <span style="font-size: 13px;">礼包内容</span>
                                </div>
                                <span style="margin: 10px 10px 10px;display: block">
                                    {{item.giftContent || '无'}}
                                </span>
                                <div class="game-detail-info" style="margin-top: 5px;">
                                    <span style="font-size: 13px;">礼包说明</span>
                                </div>
                                <span style="margin: 10px 10px 10px;display: block;">
                                    {{item.giftExplain || '无'}}
                                </span>
                                <div class="game-detail-info" style="margin-top: 5px;">
                                    <span style="font-size: 13px;">领取方式</span>
                                </div>
                                <span style="margin: 10px 10px 10px;display: block;">
                                    进入游戏后，点击游戏侧边悬浮球，在悬浮窗中点击礼包领取菜单
                                </span>
                            </div>

                        </div>
                    </div>
                    <div v-else style="font-size: 13px;color: #888888;margin: 20px 0;">
                        该游戏暂时还没有礼包
                    </div>
                </div>
            </div>

            <div class="info-model">
                <div class="main-title">
                    <span>
                        游戏活动
                    </span>
                    <span v-if="activityList.length > 3" @click="expandActivityList" class="expend-btn">
                        {{activityShowNum === 3 ? '展开全部' : '收起'}}
                    </span>
                    <div class="title-line"></div>
                </div>

                <div style="font-size: 15px;margin: 10px 20px 10px;">
                    <div v-if="activityList.length > 0">
                        <div v-for="(item,index) in activityList" v-if="index < activityShowNum" @click="openContent(item.contentId)" style="background-color: #f8f8f8;padding: 15px 20px;margin-top: 5px;
                            display: flex;align-items: center;justify-content: space-between;border-radius: 4px;cursor:pointer;">
                            <div style="display: flex;flex-direction: column;align-items: flex-start;margin-right: 20px;">
                                <span style="font-size: 13px;color: #555555;font-weight: bold;">{{item.contentName}}</span>
                                <span v-if="item.contentDes" style="font-size: 13px;color: #888888;margin-top: 5px;" class="text-info-desc">{{item.contentDes}}</span>
                            </div>
                            <van-icon name="arrow" color="#cccccc" size="18"/>
                        </div>
                    </div>
                    <div v-else style="font-size: 13px;color: #888888;margin: 20px 0;">
                        该游戏暂时还没有活动
                    </div>
                </div>
            </div>

            <div class="info-model">
                <div class="main-title">
                    <span>
                        游戏攻略
                    </span>
                    <span v-if="contentList.length > 3" @click="expandContentList" class="expend-btn">
                        {{contentShowNum === 3 ? '展开全部' : '收起'}}
                    </span>
                    <div class="title-line"></div>
                </div>

                <div style="font-size: 15px;margin: 10px 20px 10px;">
                    <div v-if="contentList.length > 0">
                        <div v-for="(item,index) in contentList" v-if="index < contentShowNum" @click="openContent(item.contentId)" style="background-color: #f8f8f8;padding: 15px 20px;margin-top: 5px;
                            display: flex;align-items: center;justify-content: space-between;border-radius: 4px;cursor:pointer;">
                            <div style="display: flex;flex-direction: column;align-items: flex-start;margin-right: 20px;">
                                <span style="font-size: 13px;color: #555555;font-weight: bold;">{{item.contentName}}</span>
                                <span v-if="item.contentDes" style="font-size: 13px;color: #888888;margin-top: 5px;" class="text-info-desc">{{item.contentDes}}</span>
                            </div>
                            <van-icon name="arrow" color="#cccccc" size="18"/>
                        </div>
                    </div>
                    <div v-else style="font-size: 13px;color: #888888;margin: 20px 0;">
                        该游戏暂时还没有攻略
                    </div>
                </div>
            </div>

            <div class="info-model bottom-view">
                <div class="main-title">
                    <span>
                        开服信息
                    </span>
                    <div class="title-line"></div>
                </div>
                <div style="font-size: 15px;margin: 10px 20px 10px;">
                    <div v-if="openServerList.length > 0">
                        <div  v-for="item in openServerList" style="height: 50px;font-size: 14px;border-bottom: 1px solid #f3f3f3;display: flex;align-items: center;padding: 0 3px;">
                            <span style="">{{item.server_name}}</span>
                            <span v-if="item.open !== 1" style="margin-left: 20px;color: #888888">{{item.open_time}}</span>
                            <span v-if="!!item.openInfo && item.open !== 1" style="margin-left: 20px;background-color: #ef580d;color: #ffffff;padding: 3px 4px;font-size: 12px;border-radius: 2px;">{{item.openInfo}}</span>
                            <span v-if="!!item.openInfo && item.open === 1" style="margin-left: 20px;border: 1px solid #ef580d;color: #ef580d;padding: 2px 3px;font-size: 12px;border-radius: 2px;">{{item.openInfo}}</span>
                        </div>
                    </div>
                    <div v-else style="font-size: 13px;color: #888888;margin: 20px 0;">
                        暂无开服信息
                    </div>
                </div>
            </div>

            <!--<div class="ios-div" style="" v-if="isM&&isSelfSigned" v-show="showInstall">点击允许后，打开手机设置->通用->VPN与设备管理，安装证书
            </div>-->
<!--            <div v-if="isIOS || !gameUrl" class="m-bottom-view">
                <div class="m-button"  @click="downloadGame">{{buttonText}}</div>
            </div>-->

            <div class="m-bottom-view">
                <!--            <div v-if="!!gameUrl" class="m-bottom-view">-->
                <div v-if="!!gameUrl" class="play-button" @click="playGame">在线玩</div>
                <div :class="!!gameUrl ? 'm-button-right' : 'm-button'" @click="downloadGame">{{buttonText}}</div>
            </div>

            <div v-if="false" class="m-bottom-view">
                <div class="ios-div" @click="goGuide" v-if="!isSelfSigned&&downloading">iOS如何授权</div>
                <div class="m-button"  @click="downloadGame">{{buttonText}}</div>
            </div>
        </div>

        <van-overlay :show="overlayShow"  class-name="overlay-view">
            <div class="overlay-panel">
                <div>
                    <van-image :src="wjtImg" width="80px" height="80px"></van-image>
                </div>
                <div class="overlay-info">
                    <p>
                        请点击右上角 ... 在默认浏览器中打开
                    </p>
                </div>
            </div>
        </van-overlay>

        <div class="me-login-view" v-if="showLogin" @click.self="showLogin = false">
            <home-login ></home-login>
        </div>

        <home-footer class="m-footer m-hidden-view"></home-footer>
    </div>
</template>

<script>

    import downloadImg from '@/assets/downloadback/button_download.jpg'
    import guideImg from '@/assets/downloadback/button_guide.jpg'
    import logo from '@/assets/logo.png'
    import wjtImg from '@/assets/weixin_arrow.png'
    import QRCode from 'qrcodejs2'
    import {request, webTokenRequest} from '@/api/request'
    import {Toast, Dialog} from 'vant'

    import homeNav from "@/components/home/HomeNav";
    import homeFooter from "@/components/home/HomeFooter";
    import homeTabbar from "@/components/home/HomeTabbar";
    import gzhCodeView from "@/components/home/GzhCodeView";
    import notice from "@/api/notice";
    import webConfig from "@/api/config";
    import HomeLogin from "@/components/home/HomeLogin.vue";
    import AppTitle from "@/components/home/AppTitle.vue";
    import AppTopSpace from "@/components/home/AppTopSpace.vue";

    export default {
        name: 'download',
        components: {
            HomeLogin,
            homeNav,
            homeFooter,
            gzhCodeView,
            homeTabbar,
            AppTitle,
            AppTopSpace,
        },
        data() {
            return {
                isSelfSigned: true,
                logoUrl: require("@/assets/logo-skeleton.png"),
                gameName: '',
                downloadImg,
                guideImg,
                wjtImg,
                logo,
                thisUrl: '',
                androidUrl: '',
                iosUrl: '',
                qrCodeShow: false,
                isM: false,
                downloading: false,
                overlayShow: false,
                showInstall: false,
                gameId: '',
                channelId: '',
                gameSystem: '',
                iosSignType: '',
                videoUrl: null,
                videoImgUrl: '',
                tagList: [],
                gameDesc: '',
                buttonText: '游戏下载',
                topic: '',
                gameSize: '',
                gameUrl: '',
                from: '',
                isBoxApp: false,
                isIOS: false,
                process: '',
                appStatus: 0,
                packageName: '',
                showLogin: false,
                openServerList: [],
                giftInfoList: [],
                contentList: [],
                activityList: [],
                giftShowNum: 3,
                contentShowNum: 3,
                activityShowNum: 3,
                config: {},
            }
        },
        mounted() {
            this.config = webConfig;
            this.from = localStorage.getItem('from');
            if (this.from === 'android_box') {
                this.isBoxApp = true;
            }
            console.log('gameDetail, from: ' + this.from);
            this.channelId = this.$route.path.split('/')[2];
            this.gameId = this.$route.path.split('/')[3];

            localStorage.setItem('channelId', this.channelId);
            /*if (!localStorage.getItem('channelId')) {
                localStorage.setItem('channelId', this.channelId);
            }*/

            if (!localStorage.getItem('udid')) {
                localStorage.setItem('udid', this.generateUUID());
            }

            let u = navigator.userAgent;
            //let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || /macintosh|mac|ipod/.test(u.toLowerCase()); //ios终端

            this.thisUrl = window.location.href
            this.isM = this.isMobile()
            if (!this.isM) {
                this.creatQrCode()
            }

            this.getGameInfo();
            if (this.isWeiXin()) {
                this.overlayShow = true
            }
            window.refreshProcess = this.refreshProcess;
            window.refreshAppInfo = this.refreshAppInfo;
        },
        methods: {
            back() {
                this.$router.back();
            },
            openContent(contentId) {
                this.$router.push("/home/contentDetail?id=" + contentId);
            },
            expandActivityList () {
                if (this.activityShowNum === 3) {
                    this.activityShowNum = 999;
                }
                else {
                    this.activityShowNum = 3;
                }
            },
            expandContentList() {
                if (this.contentShowNum === 3) {
                    this.contentShowNum = 999;
                }
                else {
                    this.contentShowNum = 3;
                }
            },
            expandGiftList() {
                if (this.giftShowNum === 3) {
                    this.giftShowNum = 999;
                }
                else {
                    this.giftShowNum = 3;
                    this.giftInfoList.forEach((e,v) => {
                        e.open = 0;
                    });
                }
            },
            selectGiftClass(open) {
                let className = "";
                switch (open) {
                    case 0:
                        break;
                    case 1:
                        className = 'gift-show';
                        break;
                    case 2:
                        className = 'gift-hide';
                        break;
                }
                return className;
            },
            playGamePC() {
                /*if (!localStorage.getItem('web_token')) {
                    this.$refs.homeNavRef.openLoginPage();
                }
                else {
                    this.getUserCredential(1);
                }*/
                this.$router.push(this.config.gameUrlMiddle + this.channelId + "/" + this.gameId + "?from=" + this.from);
            },
            playGame() {
                /*if (!localStorage.getItem('web_token')) {
                    this.showLogin = true;
                }
                else {
                    this.getUserCredential(2);
                }*/
                this.$router.push(this.config.gameUrlMiddle + this.channelId + "/" + this.gameId + "?from=" + this.from);
            },
            getUserCredential(n) {
                let options = {
                    url:"/web/getUserCredential",
                    data: {
                        gameId: this.gameId
                    }
                };
                webTokenRequest(options).then((res) => {
                    if (res.data.success === true) {
                        let credential = res.data.data;
                        let params = '?credential=' + credential + "&from=" + this.from;
                        //let hookUrl = 'https://app.xxh5.z7xz.com/login.php';
                        notice.playGame(this.gameUrl + params, null);
                        //notice.playGame('http://192.168.1.26:8080/#/h5/1/' + this.gameId + params, hookUrl);
                    }
                    else {
                        Toast(res.data.error.message);
                        if (res.data.error.code === '911') {
                            localStorage.removeItem('web_token')
                            if (n === 1) {
                                this.$refs.homeNavRef.openLoginPage();
                            }
                            else {
                                this.showLogin = true;
                            }
                        }
                    }
                });
            },
            resetPage() {
                this.showLogin = false;
            },
            refreshProcess(p) {
                this.process = p + "%";
                this.buttonText = "正在下载 (" + this.gameSize + ") " + p + "%";
                if (p === 100) {
                    this.buttonText = "下载完成";
                }
            },
            refreshAppInfo() {
                let appInfoStr = window.androidJs.getAppInstallInfo(this.packageName, this.androidUrl);
                //let appInfoStr = window.androidJs.getAppInstallInfo(this.packageName, "https://cdn.7li.club/eaoojlgn/1/shanhaijhxl.apk");
                let appInfo = JSON.parse(appInfoStr);
                this.appStatus = appInfo.status;
                if (this.appStatus === 0) {
                    this.buttonText = "游戏下载";
                }
                else if (this.appStatus === 1) {
                    this.buttonText = "已安装，点击打开";
                }
                else if (this.appStatus === 2) {
                    this.buttonText = "已下载，点击安装";
                }
            },
            openGift(index) {
                let open = this.giftInfoList[index].open;
                if (open === 0) {
                    this.giftInfoList[index].open = 1;
                }
                else if (open === 1)  {
                    this.giftInfoList[index].open = 2;
                }
                else if (open === 2)  {
                    this.giftInfoList[index].open = 1;
                }
                //this.giftInfoList[index].open = !this.giftInfoList[index].open;
            },
            getGameInfo() {
                let options = {
                    url:"/web/getGameInfo?id=" + this.gameId + "&adminId=" + this.channelId,
                    method: 'get',
                };

                request(options).then((res) => {
                    if (res.data.success === true) {
                        this.gameSystem = res.data.data.gameSystem
                        this.iosUrl = res.data.data.iosUrl
                        this.androidUrl = res.data.data.androidUrl
                        this.logoUrl = res.data.data.image_url
                        this.gameName = res.data.data.game_name
                        this.iosSignType = res.data.data.iosSignType
                        this.isSelfSigned = (res.data.data.iosSignType === 1)
                        this.videoUrl = res.data.data.videoUrl;
                        this.videoImgUrl = res.data.data.videoImgUrl;
                        this.tagList = res.data.data.tagList;
                        this.gameDesc = (res.data.data.game_desc || "")
                            .replaceAll("\n", "<br>")
                            .replaceAll("/n", "<br>")
                            .replaceAll("/t", "&nbsp;&nbsp;&nbsp;&nbsp;");
                        this.gameSize = res.data.data.game_size;
                        this.gameUrl = res.data.data.game_url;
                        this.topic = this.handlerTopic(res.data.data.game_topic);
                        this.openServerList = res.data.data.openServerList;
                        this.contentList = res.data.data.contentList;
                        this.activityList = res.data.data.activityList;

                        let giftList = res.data.data.giftInfoList;
                        if (giftList) {
                            giftList.forEach(function(e,v) {
                                e.open = 0;
                            });
                            this.giftInfoList = giftList;
                        }

                        if (this.gameSize) {
                            this.buttonText = "游戏下载 (" + this.gameSize + ")"
                        }

                        if (this.isBoxApp) {
                            this.packageName = res.data.data.package_name;
                            let appInfoStr = window.androidJs.getAppInstallInfo(this.packageName, this.androidUrl);
                            //let appInfoStr = window.androidJs.getAppInstallInfo(this.packageName, "https://cdn.7li.club/eaoojlgn/1/shanhaijhxl.apk");
                            console.log('appInfo', appInfoStr);
                            let appInfo = JSON.parse(appInfoStr);
                            this.appStatus = appInfo.status;
                            if (this.appStatus === 1) {
                                this.buttonText = "已安装，点击打开";
                            }
                            else if (this.appStatus === 2) {
                                this.buttonText = "已下载，点击安装";
                            }
                            else if (this.appStatus === 3) {
                                //let p = appInfo.data;
                                //this.buttonText = "正在下载 (" + this.gameSize + ") " + p + "%";
                            }
                            else if (this.appStatus === 4) {
                                let p = appInfo.data;
                                this.buttonText = "已暂停 (" + this.gameSize + ") " + p + "%";
                            }
                        }
                    } else {
                        Toast(res.data.error.message)
                    }
                })
            },
            handlerTopic(t) {
                switch (t) {
                    case '1':
                        return '卡牌';
                    case '2':
                        return '传奇';
                    case '3':
                        return '武侠';
                    case '4':
                        return '角色';
                    case '5':
                        return '养成';
                    case '6':
                        return '三国';
                    case '7':
                        return '模拟';
                    case '8':
                        return '策略';
                    case '9':
                        return '休闲';
                }
            },
            isWeiXin() {
                let ua = window.navigator.userAgent.toLowerCase()
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                return ua.match(/MicroMessenger/i) == 'micromessenger'
            },
            isMobile() {
                let browser = {
                    versions: function () {
                        let u = navigator.userAgent, app = navigator.appVersion;
                        return {
                            trident: u.indexOf('Trident') > -1, //IE内核
                            presto: u.indexOf('Presto') > -1, //opera内核
                            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                            iPad: u.indexOf('iPad') > -1, //是否iPad
                            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                            qq: u.match(/\sQQ/i) == " qq" //是否QQ
                        };
                    }(),
                    language: (navigator.browserLanguage || navigator.language).toLowerCase()
                }
                // return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return browser.versions.mobile || browser.versions.android || browser.versions.ios;
            },
            creatQrCode() {
                //console.log(this.$refs.qrCodeUrl.innerHTML = "");
                this.qrCode = new QRCode(this.$refs.qrCodeUrl, {
                    text: this.thisUrl,
                    width: 100,
                    height: 100,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H

                })
            },
            showDialog(msg) {
                Dialog.alert({
                    title: '提示',
                    messageAlign: 'left',
                    message: msg
                })
            },
            downloadGame() {
                let ua = navigator.userAgent.toLowerCase()
                if (this.isMobile()) {
                    if (/iphone|ipad|ipod/.test(ua)) {   //判断是否ios
                        if (this.gameId === 99999) {
                            let msg = "点击允许后，找到 对应游戏文件 点击安装，输入锁屏密码，安装之后，在桌面进行查看";
                            this.showDialog(msg);
                            window.location.href = this.iosUrl;
                            this.downloading = true;
                        } else {
                            if (this.gameSystem === 1) {
                                Toast('当前游戏暂时不支持ios，请使用安卓手机进行游戏')
                                return
                            }
                            let msg = '';
                            if (this.isSelfSigned) {
                                msg = "点击允许后，再点击去安装证书，找到刚下载好的描述文件点击安装，输入锁屏密码"
                            } else {
                                msg = '点击允许安装后，在桌面查看下载进度，下载完毕之后设置信任，操作步骤查看ios授权示例';
                            }
                            Toast(msg);
                            this.showDialog(msg);
                            window.location.href = this.iosUrl
                            this.downloading = true
                        }
                        setTimeout(() => {
                            this.showInstall = true;
                        }, 2000)

                    } else {
                        if (this.gameSystem === 2) {
                            this.showDialog('当前游戏暂时不支持安卓，请使用ios系统进行游戏')
                            return
                        }
                        if (this.isBoxApp) {//游戏盒子下载游戏
                            window.androidJs.startDownload(this.androidUrl);
                            //window.androidJs.startDownload("https://cdn.7li.club/eaoojlgn/1/shanhaijhxl.apk");
                        }
                        else {
                            window.location.href = this.androidUrl
                        }
                    }
                } else {
                    if (/macintosh|mac|ipod/.test(ua)) {
                        if (this.gameSystem === 1) {
                            this.showDialog('当前游戏暂时不支持ios，请使用安卓手机进行游戏')
                            return
                        }
                        let msg = '';
                        if (this.isSelfSigned) {
                            msg = "点击允许后，再点击去安装证书，找到刚下载好的描述文件点击安装，输入锁屏密码"
                        } else {
                            msg = '点击允许安装后，在桌面查看下载进度，下载完毕之后设置信任，操作步骤查看ios授权示例';
                        }

                        this.showDialog(msg);
                        window.location.href = this.iosUrl
                        this.downloading = true
                    } else {
                        window.location.href = this.androidUrl
                    }

                }
            },
            goGuide() {
                this.$router.push({path: '/download/iosGuide'})
            },
            generateUUID(){
                let d=new Date().getTime();
                let uuid ='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            },
        }
    }
</script>

<style scoped>
    @keyframes giftShow {
        0% {
            max-height: 0;
            height: 0;
        }
        100% {
            max-height: 400px;
            height: 100%;
        }
    }
    @keyframes giftHide {
        0% {
            max-height: 400px;
        }
        100% {
            max-height: 0;
        }
    }
    .gift-show {
        animation: giftShow 0.3s linear forwards;
    }
    .gift-hide {
        animation: giftHide 0.3s linear forwards;
    }

    .gift-more-init {
        max-height: 0;
        margin: 0 auto;
        overflow: hidden;
        text-align: left;
        font-size: 12px;
        color: #666666;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        //transition: height 4s ease;
    }

    @keyframes giftShowIcon {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(90deg);
        }
    }

    @keyframes giftHideIcon {
        0% {
            transform: rotate(90deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    .gift-show-icon {
        animation: giftShowIcon 0.3s linear forwards;
    }

    .gift-hide-icon {
        animation: giftHideIcon 0.3s linear forwards;
    }

    .info-model {
        width: 100%;
        background-color: #FFFFFF;
        border-radius: 8px;
        margin-top: 10px;
        text-align: left;
        box-sizing: border-box;
        color: #333333;
        font-size: 13px;
        padding: 0;
    }

    .main-title {
        //background: linear-gradient(180deg, #f5e5dc 0%, #ffffff 100%);
        font-weight: bold;
        font-size: 22px;
        height: 70px;
        line-height: 70px;
        padding: 0 20px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        display: flex;
        justify-content: space-between;
        position: relative;
        color: #333333;
    }

    .title-line {
        height: 1px;
        background-color: #f3f3f3;
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
    }

    .expend-btn {
        width: 60px;
        text-align: center;
        font-size: 13px;
        font-weight: normal;
        cursor: pointer;
        user-select: none;
        color: #dc6a18
    }

    .all-page {
        overflow: hidden;
        width: 100%;
        height: 100vh;
        overflow-y: auto;
        background-color: #f3f1ef;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .all-page::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }


    .main-page {
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        box-sizing: border-box;
    }

    .game-info {
        background-color: #FFFFFF;
        border-radius: 8px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 25px 35px;
        margin-top: 10px;
    }

    .p-title {
        width: 100%;
        max-width: 900px;
        height: 70px;
        background-color: #ffffff;
        border-radius: 8px;
        margin: 10px auto 0;
        z-index: 999;
        position: relative;
    }

    .tags {
        white-space: nowrap;
    }

    .tags > span {
        padding: 3px 5px;
        margin-right: 3px;
        background-color: #FDF1EB;
        color: #EC7338;
        font-size: 12px;
        text-align: left;
    }

    .game-name-text {
        font-size: 20px;
    }

    .game-icon-img {
        width: 120px;
        height: 120px;
    }

    .game-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        height: 100px;
        margin-left: 15px;
        overflow: hidden;
    }

    .download-button {
        width: 150px;
        height: 45px;
        border-radius: 40px;
        background-color: #4394FD;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
    }
    .overlay-view {
        z-index: 9999;
    }
    .m-bottom-view {
        display: none;
    }

    .m-button {
        width: 80%;
        height: 40px;
        border-radius: 40px;
        background-color: #4394FD;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
    }
    .m-button-right {
        width: 55%;
        height: 40px;
        border-radius: 10px 40px 40px 10px;
        background-color: #4394FD;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        color: #ffffff;
        user-select: none;
        cursor: pointer;
    }

    .play-button {
        width: 40%;
        height: 40px;
        margin-right: 10px;
        border-radius: 40px 10px 10px 40px;
        //border-radius: 40px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        color: #4394FD;
        border: 2px solid #4394FD;
        user-select: none;
        cursor: pointer;
    }

    .p-play-button {
        width: 150px;
        height: 45px;
        border-radius: 40px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        box-sizing: border-box;
        color: #4394FD;
        border: 2px solid #4394FD;
        user-select: none;
        cursor: pointer;
        margin-bottom: 10px;
    }

    .ios-div {
        color: #1c88e7;
        font-size: 13px;
        padding: 0 10px;
        width: 100px;
    }

    .code-div {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;
        margin-top: 10px;
        box-sizing: border-box;
    }

    .overlay-panel {
        text-align: right;
        margin-right: 15px;
        margin-top: 10px;
    }

    .overlay-info {
        text-align: center;
        width: 80%;
        margin: 20px auto;
        border-radius: 60px;
        border: 2px dashed white;
        color: white;
        font-weight: 600;
    }

    .code-view {
        margin-left: 10px;
        margin-top: 10px;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 0 15px;
    }

    .me-login-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
    }
    .bottom-view {
        margin-bottom: 20px;
    }
    .game-detail-info{
        text-align: left;
        color: #f88540;
        background-color: rgba(250, 86, 27, 0.11);
        padding: 1px 5px;
    }
    @media screen and (max-width: 900px) {
        .game-info {
            width: 90%;
            margin: 0 auto;
            padding: 15px 20px;
        }
        /*.main-page {
            margin-top: 110px;
        }*/
        .game-name-text {
            font-size: 14px;
        }
        .topic-view {
            font-size: 14px;
            margin-top: 4px;
        }
        .game-icon-img {
            width: 80px;
            height: 80px;
        }
        .game-text {
            height: 75px;
        }
        .download-button {
            display: none;
        }
        .p-title {
            display: none;
        }
        .main-title {
            font-size: 18px;
            height: 60px;
            line-height: 60px;
            padding: 0 20px;
        }
        .m-bottom-view {
            display: flex;
            height: 75px;
            position: fixed;
            bottom: 0;
            background-color: #ffffff;
            width: 100%;
            justify-content: center;
            padding: 10px 20px 0;
            box-sizing: border-box;
        }
        .code-view {
            display: none;
        }
        .m-hidden-view {
            display: none !important;
        }

        .m-footer {
            margin-bottom: 50px;
        }
        .bottom-view {
            margin-bottom: 85px;
        }
        .info-model {
            width: 90%;
            border-radius: 8px;
            padding: 0;
        }
    }
</style>
